<template>
  <b-form action="">
    <div class="d-flex">
      <b-form-group
        id="input-group-date"
        label-for="startDate"
        label="Fecha inicio"
        class="m-0"
      >
        <b-form-datepicker
          id="startDate"
          v-model="filtersB.startDate"
          placeholder="Fecha inicio"
          :date-format-options="{
            year: 'numeric', month: 'short', day: '2-digit'
          }"
          locale="es"
          name="start_date"
        ></b-form-datepicker>
      </b-form-group>
      <b-form-group
        id="input-group-endDate"
        label-for="endDate"
        label="Fecha fin"
        class="ml-2"
      >
        <b-form-datepicker
          id="endDate"
          v-model="filtersB.endDate"
          placeholder="Fecha fin"
          :date-format-options="{
            year: 'numeric', month: 'short', day: '2-digit'
          }"
          locale="es"
          name="end_date"
        ></b-form-datepicker>
      </b-form-group>
      <b-form-group
        id="input-group-seller"
        label-for="seller_id"
        label="Vendedor"
        class="ml-2"
      >
        <b-form-select
          v-model="filtersB.sellerId"
          :options="sellers"
          class="mb-3"
          value-field="id"
          text-field="name"
          name="seller_id"
        >
          <template #first>
            <b-form-select-option value="" >Seleccione</b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>        
      <b-form-group
        id="input-group-service"
        label-for="service"
        label="Servicio"
        class="ml-2"
      >
        <b-form-select
          v-model="filtersB.service"
          class="mb-3"
          name="service"
        >
          <b-form-select-option value="" >Seleccione</b-form-select-option>
          <b-form-select-option value="round trip" >Round trip</b-form-select-option>
          <b-form-select-option value="arrival" >Arrival</b-form-select-option>
          <b-form-select-option value="departure" >Departure</b-form-select-option>
        </b-form-select>
      </b-form-group>
      <b-form-group
        id="input-group-payment_type"
        label-for="payment_type"
        label="Tipo de pago"
        class="ml-2"
      >
        <b-form-select
          v-model="filtersB.payment_type"
          class="mb-3"
          name="payment_type"
        >
          <b-form-select-option value="" >Seleccione</b-form-select-option>
          <b-form-select-option value="CASH" >Cash</b-form-select-option>
          <b-form-select-option value="TDC" >TDC</b-form-select-option>
          <b-form-select-option value="TDD" >TDD</b-form-select-option>
        </b-form-select>
      </b-form-group>
      <!-- <b-form-group
        id="input-group-terminal"
        label-for="terminal"
        label="Terminal"
        class="ml-2"
      >
        <b-form-select
          v-model="filtersB.terminal"
          :options="terminals"
          class="mb-3"
          name="terminal"
        >
        </b-form-select>
      </b-form-group> -->

      <b-form-group
        id="input-group"
        class="ml-2"
        :label="`\xa0`"
      >
        <b-button type="submit" variant="primary">Buscar</b-button>
      </b-form-group>
      <b-form-group
        id="input-group"
        class="ml-2"
        :label="`\xa0`"
      >
        <b-button @click="openExcel" type="button" variant="warning">Excel</b-button>
      </b-form-group>
    </div>
    </b-form>
</template>
<script>
  export default {
    name:'SearchReservationsAdmin',
    props:['filters', 'sellers'],
    data() {
      return {
        filtersB: this.filters,
        terminals:['T2','T3','T4']
      }
    },
    mounted() {
      this.filtersB.terminal = this.filtersB.terminal || 'T2'
    },
    methods:{
      openExcel() {
        let url = `${process.env.MIX_APP_URL}/admin/reservations/report-excel`
        url += `?start_date=${this.filtersB.startDate.substring(0, 10)}&end_date=${this.filtersB.endDate.substring(0, 10)}`
        url += `&seller_id=${this.filtersB.sellerId}`
        url += `&service=${this.filtersB.service}`
        url += `&payment_type=${this.filtersB.payment_type}`
        window.open(url)
      }
    }
  }
</script>